import type { Traducao } from '../textos.ts'

/**
 * O texto do link de entidade (D-136, DS-533): uma chave só, a descrição que o leitor de tela
 * ouve depois do nome. Ela mora num `<span hidden>` único do shell, apontado por
 * `aria-describedby`, e por isso o nome acessível do link e o texto do contêiner não mudam.
 */
export const TEXTOS_DO_LINK_DA_ENTIDADE = {
  novaAba: { 'pt-BR': 'abre em nova aba', 'es-419': 'se abre en una pestaña nueva', 'en-US': 'opens in a new tab' },
} as const satisfies Readonly<Record<string, Traducao>>
